import { css } from 'linaria';
import { StylesMap } from 'types/utils';

export const promoBlock = css`
  border-radius: 24px;
  position: relative;
`;

export const promoBlockBg = css`
  width: 100%;
  position: absolute;
  z-index: -1;
`;

export const promoBlockCards = css`
  display: grid;
  gap: 24px;
  padding: 256px 32px 0 32px;
  grid-template-rows: 152px;
  position: relative;

  @media (--only-desktop) {
    padding-left: 40px;
    padding-right: 40px;
  }

  @media (--only-tablet) {
    padding: 197px 24px 0 24px;
    gap: 16px;
  }

  @media (--only-mobile) {
    padding: 45% 16px 0 16px;
    grid-template-rows: unset;
    gap: 12px;
  }
`;

export const PROMO_BLOCK_CARDS_MAP_GRID: StylesMap<number> = {
  1: css`
    grid-template-columns: 1fr;
  `,
  2: css`
    grid-template-columns: 1fr 1fr;
  `,
  3: css`
    grid-template-columns: 1fr 1fr 1fr;

    @media (--to-desktop) {
      grid-template-columns: 1fr 1fr;

      :nth-child(1) {
        grid-column: auto / span 2;
      }
    }

    @media (--only-tablet) {
      grid-template-rows: 152px 152px;
    }
  `,
  4: css`
    grid-template-columns: repeat(4, 1fr);

    @media (--to-desktop) {
      grid-template-columns: 1fr 1fr;
    }

     @media (--only-tablet) {
      grid-template-rows: 152px 152px;
    }
  `,
  5: css`
    grid-template-columns: repeat(5, 1fr);
    
    @media (--only-desktop) {
      grid-template-columns: repeat(5, 152px);
    }

    @media (--only-tablet) {
      grid-template-columns: 193px 89px 89px 193px;
      grid-template-rows: 152px 152px;

      :nth-child(1),
      :nth-child(2),
      :nth-child(4) {
        grid-column: auto / span 2;
      }
    }

    @media (--only-mobile) {
      grid-template-columns: 1fr 1fr;

      :nth-child(1) {
        grid-column: auto / span 2;
      }
    }
  `,
};

export const promoBlockCard = css`
  border-radius: var(--rounding-l);

  img {
    border-radius: var(--rounding-l);
    width: 100%;
    height: 100%;

    @media (--only-mobile) {
      height: unset;
    }
  }
`;